import { useState, useEffect } from "react";
import { Smartphone, Download, Copy } from "lucide-react";
import { toast } from "sonner";

export function InstallApp({ variant = "card" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onBIP);
    window.addEventListener("appinstalled", onInstalled);
    if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) setInstalled(true);
    if (window.navigator.standalone) setInstalled(true);
    return () => { window.removeEventListener("beforeinstallprompt", onBIP); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const url = window.location.origin;
  const install = async () => {
    if (!deferred) { setShowHelp((v) => !v); return; }
    deferred.prompt();
    try { await deferred.userChoice; } catch (err) { console.debug("install prompt dismissed:", err); }
    setDeferred(null);
  };
  const copyLink = () => { navigator.clipboard?.writeText(url); toast.success("Link copiato"); };

  if (installed) return null;

  const Help = () => (!showHelp ? null : (
    <div data-testid="install-help" className="mt-2 bg-[#0d1320] border border-[#222D42] rounded-lg p-3 text-xs text-slate-400 space-y-1">
      <p className="text-slate-300 font-medium">Come installarla manualmente:</p>
      <p>📱 <b>Android (Chrome):</b> menu ⋮ in alto a destra → "Installa app".</p>
      <p>🍎 <b>iPhone (Safari):</b> tasto Condividi → "Aggiungi a Home".</p>
      <p>💻 <b>PC (Chrome/Edge):</b> icona "Installa" nella barra degli indirizzi.</p>
      <button data-testid="copy-app-link" onClick={copyLink} className="mt-1 inline-flex items-center gap-1.5 text-amber-400 hover:text-amber-300"><Copy className="w-3.5 h-3.5" /> Copia link app</button>
    </div>
  ));

  if (variant === "compact") {
    return (
      <div data-testid="install-app-compact">
        <button data-testid="install-app-button" onClick={install} className="w-full flex items-center justify-center gap-2 bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/30 px-3 py-2 rounded-lg text-xs font-semibold transition-colors">
          <Download className="w-4 h-4" /> Installa app
        </button>
        <Help />
      </div>
    );
  }

  return (
    <div data-testid="install-app-card" className="bg-gradient-to-br from-amber-500/10 to-[#121824] border border-amber-500/30 rounded-xl p-5 mb-6">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-lg bg-amber-500 text-slate-950 flex items-center justify-center shrink-0"><Smartphone className="w-5 h-5" /></div>
        <div className="flex-1 min-w-0">
          <h3 className="font-head font-semibold text-slate-100">Installa l'app sul telefono</h3>
          <p className="text-slate-400 text-xs mt-0.5">Aggiungila alla schermata Home per accedere con un tocco.</p>
          <div className="flex flex-wrap gap-2 mt-3">
            <button data-testid="install-app-button" onClick={install} className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold px-4 py-2 rounded-lg text-sm transition-colors"><Download className="w-4 h-4" /> Installa app</button>
            <button data-testid="copy-app-link" onClick={copyLink} className="inline-flex items-center gap-2 bg-[#1A2335] hover:bg-[#222D42] text-slate-200 border border-[#222D42] px-4 py-2 rounded-lg text-sm transition-colors"><Copy className="w-4 h-4" /> Copia link</button>
          </div>
          <p className="text-[11px] text-slate-600 mt-2 break-all">{url}</p>
          <Help />
        </div>
      </div>
    </div>
  );
}
